import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "../lib/api";
import { getAttributionToken, clearAttribution } from "../lib/marketingAttribution";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch (e) { return null; }
  };
  const loginWithGoogle = async (code) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Login nativo con Google: el código de autorización se intercambia en el backend.
    //
    // `ref` es el código de quien lo trajo, guardado al entrar por un enlace de referido (ver
    // el efecto que lee ?ref= en Landing). Se manda SIEMPRE que exista: el backend solo lo usa
    // si la cuenta es nueva, así que reenviarlo en un login normal no hace nada. No se borra
    // aquí sino tras un registro con éxito, para que un login fallido no pierda la atribución.
    const ref = localStorage.getItem("vb_ref") || undefined;
    const attribution_token = await getAttributionToken();
    const { data } = await api.post("/auth/google", { code, ref, attribution_token });
    clearAttribution();
    if (data?.created) localStorage.removeItem("vb_ref");
    localStorage.setItem("vb_token", data.token);
    // Igual que refreshUser() de arriba: /auth/google tampoco devuelve "settings".
    return await refreshUser();
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("vb_token");
    setUser(false);
    // A la landing, no a /login: cerrar sesión es una acción deliberada del usuario, distinta de
    // que <Protected> (App.js) te mande a /login porque la sesión caducó sola o entraste a una
    // URL protegida sin sesión — ese caso sigue yendo a /login a propósito, para volver a entrar
    // rápido. Recarga completa (no navigate() de React Router) porque AuthContext vive FUERA de
    // BrowserRouter — mismo motivo y mismo patrón que ya usa stopImpersonating más abajo.
    window.location.href = "/";
  };
  // Vuelve de "ver como este usuario" (AdminUserPage) a la sesión real del admin. Recarga
  // completa a propósito, igual que al entrar — mismo motivo: cookie nueva, estado limpio.
  const stopImpersonating = async () => {
    try { await api.post("/auth/impersonate/stop"); } catch (e) {}
    window.location.href = "/admin";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loginWithGoogle, logout, refreshUser, stopImpersonating, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}
